import { render, staticRenderFns } from "./SupInvoiceaddFB.vue?vue&type=template&id=261a4311&scoped=true"
import script from "./SupInvoiceaddFB.vue?vue&type=script&lang=js"
export * from "./SupInvoiceaddFB.vue?vue&type=script&lang=js"
import style0 from "./SupInvoiceaddFB.vue?vue&type=style&index=0&id=261a4311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261a4311",
  null
  
)

export default component.exports